module.exports = __webpack_public_path__ + "img/chateau_vecquee_foule.14786822.jpg";